import { StyleProp } from "react-native";

export default function composePropsWithDefaultStyles<
  T,
  StylePropType extends StyleProp<T>,
  Props extends { style: StylePropType }
>(defaultStyles: StylePropType, { style, ...rest }: Props) {
  return { style: [defaultStyles, style], ...rest };
}
